// extracted by mini-css-extract-plugin
export default {"vehicle":"AddDependent_vehicle__0XyhL","campos":"AddDependent_campos__MiaPd","botao":"AddDependent_botao__Y82S2"};